// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-management-page {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
}

.page-header p {
  color: #666;
  margin: 0;
}

.error-message {
  background: #fee;
  color: #c00;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.error-message button {
  background: none;
  border: none;
  color: #c00;
  cursor: pointer;
  font-size: 16px;
}

.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.tab-btn {
  padding: 10px 20px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  color: #666;
}

.tab-btn:hover {
  background: #e9ecef;
}

.tab-btn.active {
  background: #4A964E;
  border-color: #4A964E;
  color: white;
}

.loading-spinner {
  text-align: center;
  padding: 40px;
  color: #666;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #f8f9fa;
  border-radius: 12px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  color: #333;
}

.empty-state p {
  color: #666;
  margin: 0;
}

.feedback-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.feedback-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-left: 4px solid #ddd;
}

.feedback-card.new {
  border-left-color: #ffc107;
}

.feedback-card.accepted {
  border-left-color: #28a745;
}

.feedback-card.rejected {
  border-left-color: #dc3545;
}

.feedback-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.feedback-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.feedback-icon {
  font-size: 20px;
}

.feedback-subject {
  font-weight: 600;
  color: #333;
}

.feedback-id {
  color: #999;
  font-size: 13px;
}

.feedback-date {
  color: #666;
  font-size: 13px;
}

.feedback-body {
  padding: 20px;
}

.feedback-message {
  margin: 0;
  color: #444;
  line-height: 1.6;
  white-space: pre-wrap;
}

.feedback-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fafafa;
  border-top: 1px solid #eee;
}

.feedback-user {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.user-icon {
  font-size: 16px;
}

.feedback-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.action-btn.accept {
  background: #28a745;
  color: white;
}

.action-btn.accept:hover:not(:disabled) {
  background: #218838;
}

.action-btn.reject {
  background: #dc3545;
  color: white;
}

.action-btn.reject:hover:not(:disabled) {
  background: #c82333;
}

.action-btn.revert {
  background: #6c757d;
  color: white;
}

.action-btn.revert:hover:not(:disabled) {
  background: #5a6268;
}

.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .feedback-management-page {
    padding: 16px;
  }

  .tabs {
    flex-direction: column;
  }

  .feedback-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .feedback-footer {
    flex-direction: column;
    gap: 12px;
  }

  .feedback-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/FeedbackManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".feedback-management-page {\n  padding: 24px;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h2 {\n  font-size: 28px;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.page-header p {\n  color: #666;\n  margin: 0;\n}\n\n.error-message {\n  background: #fee;\n  color: #c00;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.error-message button {\n  background: none;\n  border: none;\n  color: #c00;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.tab-btn {\n  padding: 10px 20px;\n  background: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #666;\n}\n\n.tab-btn:hover {\n  background: #e9ecef;\n}\n\n.tab-btn.active {\n  background: #4A964E;\n  border-color: #4A964E;\n  color: white;\n}\n\n.loading-spinner {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: #f8f9fa;\n  border-radius: 12px;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.empty-state p {\n  color: #666;\n  margin: 0;\n}\n\n.feedback-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.feedback-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  border-left: 4px solid #ddd;\n}\n\n.feedback-card.new {\n  border-left-color: #ffc107;\n}\n\n.feedback-card.accepted {\n  border-left-color: #28a745;\n}\n\n.feedback-card.rejected {\n  border-left-color: #dc3545;\n}\n\n.feedback-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #eee;\n}\n\n.feedback-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.feedback-icon {\n  font-size: 20px;\n}\n\n.feedback-subject {\n  font-weight: 600;\n  color: #333;\n}\n\n.feedback-id {\n  color: #999;\n  font-size: 13px;\n}\n\n.feedback-date {\n  color: #666;\n  font-size: 13px;\n}\n\n.feedback-body {\n  padding: 20px;\n}\n\n.feedback-message {\n  margin: 0;\n  color: #444;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.feedback-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #fafafa;\n  border-top: 1px solid #eee;\n}\n\n.feedback-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #666;\n  font-size: 14px;\n}\n\n.user-icon {\n  font-size: 16px;\n}\n\n.feedback-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.action-btn.accept {\n  background: #28a745;\n  color: white;\n}\n\n.action-btn.accept:hover:not(:disabled) {\n  background: #218838;\n}\n\n.action-btn.reject {\n  background: #dc3545;\n  color: white;\n}\n\n.action-btn.reject:hover:not(:disabled) {\n  background: #c82333;\n}\n\n.action-btn.revert {\n  background: #6c757d;\n  color: white;\n}\n\n.action-btn.revert:hover:not(:disabled) {\n  background: #5a6268;\n}\n\n.action-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .feedback-management-page {\n    padding: 16px;\n  }\n\n  .tabs {\n    flex-direction: column;\n  }\n\n  .feedback-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .feedback-footer {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .feedback-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
